module.exports = __webpack_public_path__ + "img/visuel-md@2x.59deab2b.jpg";